export const stringToNumberArr = (value: string): number[] => {
  return value
    .split(',')
    .map((i) => i?.trim())
    .filter(Boolean)
    .map(Number)
    .filter((n): n is number => !Number.isNaN(n));
};

export const stringToArr = (value: string) => {
  return value.split(',').map((i) => i?.trim());
};

export const spaceReplacer = (value: string) => {
  return value?.toUpperCase().replaceAll(' ', '-');
};

export const truncateText = (text: string, maxLength = 100) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export const formatText = (text: string) => {
  if (!text) return '';
  return text.replace(/-/g, ' ').replace(/_/g, ' ').toLowerCase();
};

export const getPercentage = (value?: number, total?: number) => {
  if (!value || !total) return 0;
  return Math.ceil((value / total) * 100);
};

export const isValidNumber = (val: any) =>
  typeof val === 'number' && val !== null && val !== undefined && !Number.isNaN(val);
export const isNonEmptyString = (val: any) => typeof val === 'string' && val.trim() !== '';
